import { createContext } from 'react';

const MapWrapperContext = createContext();
export default MapWrapperContext;
